import React, { useEffect, useMemo, useState } from "react";
import { isMaxLength, isMinLength, isPattern } from "@formiz/validations";
import { toast } from "react-toastify";
import { useForm } from "@formiz/core";
import CommunEditModal from "../../../components/Modal/CommunEditModal";
import FormWizard from "../../../components/Form/FormWizard";
import TableComponent from "../../../components/Table/TableComponent";
import CommunModal from "../../../components/Modal/CommunModal";
import APICall, {
  explodeDataWithRowTable,
} from "../../../components/Api/APICall";

export default function CustomerManagement() {
  const [EditInputDefaultValue, setEditInputDefaultValue] = useState({
    location: "",
    userName: "",
    shopName: "",
    Contact: "",
  });
  const [ShowEditModal, setShowEditModal] = useState(false);
  const [Customer, setCustomer] = useState({
    row: [],
    dataWithRows: [],
    onlyData: [],
  });
  const [showModal, setShowModal] = useState(false);
  const col = [
    {
      accessor: "id",
      Header: "#",
      Cell: (cell) => {
        return (
          <i
            onClick={() => EditHandoler(cell.row.original)}
            title="Edit Customer"
            className="fa fa-edit cursor-pointer text-green-500 hover:text-orange-500 active:text-blue-500"
          ></i>
        );
      },
    },
    {
      accessor: "name",
      Header: "Customer Name",
    },
    {
      accessor: "shop_name",
      Header: "Shop Name",
    },
    {
      accessor: "contact",
      Header: "Contact",
    },
    {
      accessor: "location",
      Header: "Location",
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const myForm = useForm();
  const editFormSubmit = (values) => {
    values.TableId = EditInputDefaultValue.tableId;
    setIsLoading(true);
    APICall("/user/update", "POST", values)
      .then((data) => {
        if (data.status) {
          toast.success("User Successfully Updated");
          CustomerAPiCall();
        } else {
          toast.error("Please try again");
        }
        setIsLoading(false);
        setShowEditModal(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Contact to developer Error : " + err);
      });
  };
  const submitForm = (values) => {
    setIsLoading(true);
    APICall("/user/add", "POST", values).then((response) => {
      if (response.status) {
        setIsLoading(false);
        myForm.reset();
        toast.success(response.message);
        CustomerAPiCall();
      } else {
        toast.error(response.message);
      }
    });
  };

  const CustomerAPiCall = () => {
    APICall("/user/getCustomer").then((data) => {
      if (data.status) {
        explodeDataWithRowTable(data.message, setCustomer);
      }
    });
  };

  const EditHandoler = (row) => {
    setEditInputDefaultValue({
      tableId: row.tableId,
      location: row.location,
      userName: row.name,
      Contact: row.contact,
      shopName: row.shop_name,
    });
    setShowEditModal(true);
  };

  const inptFildes = useMemo(
    () => [
      {
        title: "Add New Customer",
        fileds: [
          {
            name: "userName",
            label: "Customer Name",
            required: "Customer name is required",
            type: "text",
            defaultValue: EditInputDefaultValue.userName,
          },
          {
            name: "shopName",
            label: "Shop Name",
            required: "Shop Name is required",
            type: "text",
            defaultValue: EditInputDefaultValue.shopName,
          },
          {
            name: "Contact",
            label: "Contact Number",
            type: "text",
            required: "Contact Number is required",
            defaultValue: EditInputDefaultValue.Contact,
            validations: [
              {
                rule: isPattern("^[0-9]*$"),
                message: "only Number value allowed",
              },
              {
                rule: isMinLength(10),
                message: "This should at least have a length of 4",
              },
              {
                rule: isMaxLength(10),
                message: "This should at least have a length of 10",
              },
            ],
          },
          {
            name: "location",
            label: "Shop Location",
            required: "Shop location is required",
            type: "text",
            defaultValue: EditInputDefaultValue.location,
          },
        ],
      },
    ],
    [EditInputDefaultValue]
  );

  useEffect(() => {
    CustomerAPiCall();
  }, []);
  return (
    <>
      <h3 className="text-center font-bold text-xl uppercase bg-blue-200 p-2 ">
        Customer Management
      </h3>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <CommunEditModal
          showModal={ShowEditModal}
          setShowModal={setShowEditModal}
          Title="Update Customer"
        >
          <FormWizard
            inputes={inptFildes}
            showStep={false}
            isLoading={isLoading}
            submitForm={editFormSubmit}
            myForm={myForm}
          />
        </CommunEditModal>
        <TableComponent
          columns={col}
          data={Customer.dataWithRows}
          pagination={true}
          exportData={true}
          TicketsTitle={`Customers List`}
          other={
            <CommunModal
              showModal={showModal}
              setShowModal={setShowModal}
              btnName="Add Customer"
              Title="Add New Customer"
            >
              <FormWizard
                inputes={inptFildes}
                showStep={false}
                isLoading={isLoading}
                submitForm={submitForm}
                myForm={myForm}
              />
            </CommunModal>
          }
        />
      </div>
    </>
  );
}
